import React, { useCallback, useRef, useState } from 'react';

export const useContextualMenu = () => {
  const anchorRef = useRef<HTMLElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const show = useCallback((ev: React.MouseEvent<HTMLElement>) => {
    ev.stopPropagation();
    ev.preventDefault();
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => setIsOpen(false), []);

  return { anchorRef, isOpen, show, hide };
};
